<template>
    <BootstrapModal ref="modal">
        <div class="modal-header pb-0">
            <CloseButton @click="dismiss" class="ml-auto"/>
        </div>
        <div class="modal-body">
            <div v-if="user">
                <div v-if="user" class="d-block mx-auto user-avatar user-avatar-xl bg-gray mb-2">
                    <img :src="user.profile_image_url" alt="" style="background-color:#CCC;">
                </div>
                <h5 class="text-center mb-0">Tip {{ user.display_name }}</h5>
                <p class="text-center mb-3">Select an option and add a message!</p>
            </div>
            <div v-if="!isLoading && tipOptions" class="form-group">
                <div v-if="tipOptions" class="mb-3">
                    <div v-for="tipOption in tipOptions" class="rounded btn-subtle-success w-100 p-2 mb-1" style="cursor:pointer;" @click="updateTip(tipOption.amount, tipOption.title);">
                        <b>{{ tipOption.title }}</b>
                        <div v-if="tipOption.description">{{ tipOption.description }}</div>
                        <div class="d-block">
                            <span class="text-left">${{ tipOption.amount }}</span>
                            <span style="float:right;"><i class="fa fa-angle-right"></i></span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isLoading" class="text-center mb-4">
                <i class="fad fa-2x fa-spin fa-spin-fast fa-spinner-third mb-2"></i>
                <div>Loading Tip Options</div>
            </div>
            <div v-if="!isLoading">
                <div class="form-group">
                    <label>Amount to Tip</label>
                    <div class="input-group">
                        <label class="input-group-prepend" for="amount"><span class="badge">$</span></label>
                        <input type="text" id="amount" name="amount" class="form-control" placeholder="Amount" v-model="amount">
                    </div>
                    <div v-if="hasError('amount')" v-for="error in errors['amount']" class="d-block invalid-feedback">
                        <i class="fa fa-exclamation-circle fa-fw"></i> {{ error }}
                    </div>
                </div>
                <div class="form-group">
                    <label>Attach a Message</label>
                    <textarea ref="message" id="message" name="message" class="form-control" placeholder="Add a message to send with your tip" v-model="message"></textarea>
                    <div v-if="hasError('message')" v-for="error in errors['message']" class="d-block invalid-feedback">
                        <i class="fa fa-exclamation-circle fa-fw"></i> {{ error }}
                    </div>
                </div>
                <div class="form-group">
                    <button @click="tip" type="button" class="btn rounded-pill w-100" :disabled="amount === null || isTipping" :class="{'btn-primary': amount != null, 'btn-secondary': amount === null}">
                        <span v-if="isTipping"><i class="fa fa-spin fa-spinner"></i> Redirecting...</span>
                        <span v-else>Send Tip</span>
                    </button>
                </div>
            </div>
        </div>
    </BootstrapModal>
</template>

<script>
    import BootstrapModal from "./Modals/BootstrapModal";
    import CloseButton from "./Modals/CloseButton";
    export default {
        components: {
            CloseButton,
            BootstrapModal,
        },
        data: function() {
            return {
                isLoading: true,
                isTipping: false,
                userId: null,
                user: null,
                tipOptions: null,
                amount: null,
                message: null,
                errors: {},
            }
        },
        mounted() {

            // cancel tipping state when navigating back
            window.addEventListener('pageshow', event => {
                if(event.persisted){
                    this.isTipping = false;
                }
            });

        },
        methods: {
            hasError(key) {
                return Object.keys(this.errors).includes(key);
            },
            clearErrors() {
                this.errors = [];
            },
            show: function(userId, postId, returnUrl) {
                this.reset();
                this.userId = userId;
                this.postId = postId;
                this.returnUrl = returnUrl;
                this.$refs.modal.show();
                this.load();
            },
            reset: function() {
                this.isLoading = true;
                this.isTipping = false;
                this.user = null;
                this.userId = null;
                this.postId = null;
                this.returnUrl = null;
                this.tipOptions = null;
                this.amount = null;
                this.message = null;
                this.errors = {};
            },
            dismiss: function() {
                this.$refs.modal.hide();
            },
            load: function() {

                this.isLoading = true;

                axios.get(route('web-api.users.tip-options', this.userId)).then((response) => {
                    const json = response.data;
                    this.user = json.user;
                    this.tipOptions = json.tip_options;
                }).catch((err) => {
                    this.dismiss();
                    alert(err);
                }).then(() => {
                    this.isLoading = false;
                });

            },
            updateTip: function(amount, title) {

                // update details
                this.amount = amount;
                this.message = title;

                // focus message input
                this.$refs['message'].focus();

            },
            tip: function() {

                // do nothing if already tipping
                if(this.isTipping){
                    return;
                }

                this.isTipping = true;

                // clear errors
                this.clearErrors();

                // fetch purchase url for tip
                axios.post(route('web-api.v1.users.tip', this.userId), {
                    amount: this.amount,
                    message: this.message,
                    post_id: this.postId,
                    return_url: this.returnUrl,
                }).then((response) => {
                    const json = response.data;
                    window.location = json.redirect;
                }).catch((error) => {

                    this.isTipping = false;

                    // update errors
                    if(error.response?.data?.errors){
                        this.errors = error.response.data.errors;
                    } else {
                        var err = error.response?.data?.message || error.response?.statusText || error;
                        alert(err);
                    }

                });

            }
        },
    }
</script>
